import React, { FC } from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'

import IconButton from '@material-ui/core/IconButton'

// @src imports
import { noop } from 'src/helpers/appHelpers'

import { Dialog, Icon } from 'src/chrome'
import { useState } from 'src/hooks'
// relative imports
import Payment, { PaymentInfo } from '../containers/Payment'

import styles from '../containers/styles'
import { Text } from '@sendoutcards/quantum-design-ui'

interface Props {
  isOpen: boolean
  paymentInfo?: PaymentInfo
  onClose?: () => void
  onSuccess?: () => void
  onError?: (error: Error | string) => void
}

const PaymentModal: FC<Props> = props => {
  const [isPurchasing, setIsPurchasing] = useState(false)
  const [isPaymentSuccessful, setIsPaymentSuccessful] = useState(false)

  const { isOpen, paymentInfo, onClose, onSuccess, onError } = props

  return (
    <Dialog
      open={isOpen}
      onClose={isPurchasing ? noop : onClose}
      scroll={'paper'}
    >
      <DialogTitle disableTypography={true}>
        {!isPaymentSuccessful && (
          <Text type="body" color="primaryHeading">
            {'Checkout'}
          </Text>
        )}
        {!isPurchasing && (
          <IconButton
            id="close_btn"
            style={{
              position: 'absolute',
              right: 12,
              top: 6,
            }}
            aria-label="close"
            onClick={onClose}
          >
            <Icon icon={'CLOSE'} color={'#6f8394'} size={18} />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent dividers={true} css={styles.paymentModal}>
        <Payment
          paymentInfo={paymentInfo}
          onPurchasingChange={setIsPurchasing}
          onPurchaseSuccess={() => {
            onSuccess?.()
            setIsPaymentSuccessful(true)
          }}
          onPurchaseError={onError}
          onClose={() => {
            onClose?.()
            setIsPaymentSuccessful(false)
          }}
        />
      </DialogContent>
    </Dialog>
  )
}

export default PaymentModal
